import { render, staticRenderFns } from "./ProfitAndLossBarReport.vue?vue&type=template&id=0d68228f&scoped=true&"
import script from "./ProfitAndLossBarReport.vue?vue&type=script&lang=js&"
export * from "./ProfitAndLossBarReport.vue?vue&type=script&lang=js&"
import style0 from "./ProfitAndLossBarReport.vue?vue&type=style&index=0&id=0d68228f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d68228f",
  null
  
)

export default component.exports